// src/tiles/MeasureTile.jsx
import React from 'react';
import TileShell from './TileShell';
import InterviewsBadge from './InterviewsBadge';
import ReceiptsList from './ReceiptsList';

export default function MeasureTile({ title, count, receipts, sectionTotal }) {
  const pct = sectionTotal ? Math.round((count / sectionTotal) * 100) : 0;
  const metricsRow = <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}><InterviewsBadge percent={pct} count={count} /></div>;
  return (
    <TileShell
      typePill="measure"
      title={title}
      metricsRow={metricsRow}
      receipts={<ReceiptsList receipts={receipts || []} />}
    />
  );
}
